import { z } from 'zod'

export const ADMINUSERCREDITSPOST_CONTRACT_VERSION = '1.0.0' as const
export const adminUserCreditsPostResponseSchema = z.unknown()
export type AdminUserCreditsPostResponse = z.infer<typeof adminUserCreditsPostResponseSchema>
